import styled from 'styled-components';

export const CouponDetailWrapStyle = styled.div`
  display: flex;

  .coupon-detail-statistics {
    flex: 0.3 1;
    margin-right: 20px;
  }

  .coupon-detail-info {
    flex: 0.7 1;
    overflow: auto;
  }
`;
